import React from 'react';
import {Container, Grid, Segment, Header, Form, Button, Icon} from 'semantic-ui-react';
import ReCAPTCHA from 'react-google-recaptcha';
import DHSInfo from 'go/components/static/DHSInfo';
import {Link} from 'react-router-dom';
import {dispatch} from 'rxjs/internal/observable/pairs';
import ApiActions from 'go/actions/api';
import {push} from 'react-router-redux';
import {LOGOUT} from 'common/types';
import {connect} from 'react-redux';

/* 
  TODO refactor AccountWrapper so that it provides all common methods as props 
  to account pages rather than getting called by them. Add
*/
export class AccountWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  ignoreDefaultWithCancel = (e) => {
    e.preventDefault();
    this.props.cancelAction();
  };

  ignoreDefaultWithConfirm = (e) => {
    e.preventDefault();
    this.props.confirmAction(e);
  };

  handleRecaptchaChange = (response) => {
    this.props.handleRecaptchaChange(this.grecaptcha, response);
  };

  setRes = (r) => {
    this.grecaptcha = r;
  };

  renderCaptcha = () => {
    return (
      <Form.Field>
        <ReCAPTCHA
          ref={this.setRes}
          sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
          onChange={this.handleRecaptchaChange}
        />
      </Form.Field>
    );
  };

  renderForm = () => {
    let {
      title,
      handleSubmit,
      children,
      handleRecaptchaChange,
      type,
      buttonText,
      disabled,
      showNav,
    } = this.props;
    showNav = showNav !== undefined ? showNav : true;
    return (
      <Form onSubmit={handleSubmit}>
        {/* Content to wrap around such as errors */}
        {children}
        {/* Add Recaptcha */}
        {handleRecaptchaChange && this.renderCaptcha()}
        {showNav && (
          <Form.Field>
            <Button
              title={title}
              primary={type && type === 'alert' ? undefined : true}
              disabled={disabled}
              onClick={this.ignoreDefaultWithConfirm}
              color={type && type === 'alert' ? 'red' : undefined}
            >
              {buttonText ? buttonText : 'Confirm'}
            </Button>
          </Form.Field>
        )}
        <Form.Field>
          <Link
            to={this.props.cancelToLogin ? '#' : '/'}
            onClick={async (e) => {
              if (!this.props.cancelToLogin) {
                return;
              }
              e.preventDefault();
              await this.props.logout();
            }}
          >
            <Icon title={'Cancel ' + title} name="cancel" />
            Cancel
          </Link>
        </Form.Field>
      </Form>
    );
  };

  render() {
    const {title, guidance} = this.props;
    const renderedForm = this.renderForm();
    return (
      <React.Fragment>
        <div id="main">
          <Container>
            <Segment>
              <Grid centered columns={1}>
                <Grid.Column width={16}>
                  <Header as="h1">Welcome to FEMA Grants Outcomes!</Header>
                  Grants Outcomes (GO) is FEMA's new platform for submitting, approving,
                  and managing FEMA grants.
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <Segment>
                    <Header as="h3" dividing color="blue">
                      {title}
                    </Header>
                    <p>{guidance}</p>
                    {renderedForm}
                  </Segment>
                </Grid.Column>
              </Grid>
              <DHSInfo consent privacy />
            </Segment>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => ({});

export const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(ApiActions.auth.disableCookie());
      dispatch({type: LOGOUT});
      window.location.href = '/login';
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountWrapper);
